import { SidebarSection } from '@shared';

export const ADMIN_MENU_ITEMS: SidebarSection[] = [
  /*{
    label: 'Secciones',
    items: [
      {
        label: 'Dashboard',
        icon: 'fa-solid fa-border-all',
        route: '/account/dashboard',
        permissions: [],
      },
    ],
  },*/
  {
    label: 'Bases de datos',
    items: [
      {
        label: 'Usuarios del sistema',
        icon: 'fa-solid fa-user',
        route: '/account/users',
        permissions: [['userAdminType', 'getUserAdminList']],
      },
      {
        label: 'Fraccionamientos',
        icon: 'fa-solid fa-house-user',
        route: '/account/residential-developments',
        permissions: [['userAdminType', 'getResidentialList']],
      },
      {
        label: 'Perfiles y permisos de gestor',
        icon: 'fa-solid fa-user-shield',
        route: '/account/profiles-permissions-managers',
        permissions: [['userAdminType', 'getUserGestorTypeList']],
      },
      {
        label: 'Perfiles y permisos de administrador',
        icon: 'fa-solid fa-user-shield',
        route: '/account/profiles-permissions-admins',
        permissions: [['userAdminType', 'getUserAdminTypeList']],
      },
    ],
  },
];
